<p>
  sem-control works!
</p>
